import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { InteractionType, KeyValues10, LocalService, PageKey, RelationShipRole, Status } from 'src/service/local.service';
import { QrlabelService } from 'src/service/qrlabel.service';

@Component({
  selector: 'app-qr-label-generator',
  templateUrl: './qr-label-generator.component.html',
  styleUrl: './qr-label-generator.component.scss'
})
export class QrLabelGeneratorComponent {
  lstSectionConfigKeys: string[] = ["qr_label_gen"]; RelationShipRole = RelationShipRole;
  ctryCode: string = ''; businessId: string = ''; userId: string = ''; interactionType = 0;

  templates: KeyValues10[] = []; isShowDeleted = false; maxBodyHeight = 0;

  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private languageManagementService: LanguageManagementService, private qrlabelService: QrlabelService, private router: Router, private cdr: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.userId = routeParams.userId;
      this.configurationManagementService.ensurePageActions(PageKey.QrLabelGenerator, this.businessId);
      if (this.interactionType != InteractionType.User && (!this.businessId || this.businessId.length < 5)) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onLoad();
  }

  onLoad() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.qrlabelService.getQrLabelTemplates(this.businessId, !this.isShowDeleted).subscribe(result => {
        this.templates = result;
      });
    }
  }

  onAction(index: number, key: string = '') {
    switch (index) {
      case 1: {
        this.router.navigate(['/qr-template-config' + this.localService.basicParamsString, this.businessId, key && key.length > 5 ? key : '0']);
      } break;
      case 2: {
        this.onRemove(key);
      } break;
      case 3: {
        this.router.navigate(['/qr-label-upload' + this.localService.basicParamsString, this.businessId, key && key.length > 5 ? key : '0']);
      } break;
    }
  }

  onRemove(key: string) {
    this.qrlabelService.deletQrLabelTemplate(key).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success)
        this.templates = this.templates.filter(x => x.key != key);
    });
  }
}
